import React from 'react'
import MaterialTable from 'material-table'
import { useMutation } from '@apollo/react-hooks'
import { DESTROY_USER } from './queries'

function UsersTable(props) {
  const [destroyUser] = useMutation(DESTROY_USER)

  const columns = [
    { title: 'Nome', field: 'name' },
    { title: 'E-mail', field: 'email' },
    { title: 'Perfil', field: 'profile' },
    { title: 'Responsável por', field: 'role' },
    { title: 'Último login em', field: 'lastLoginAt', type: 'date' },
    { title: 'Criado em', field: 'createdAt', type: 'date' },
  ]

  return (
    <MaterialTable
      title="Usuários Cadastrados"
      columns={ columns }
      data={ props.data }
      style={{ boxShadow: 'none' }}
      options={{
        pageSize: 20,
        pageSizeOptions: [20, 50, 100]
      }}
      localization={{
        header: {
          actions: 'Ações',
        },
        pagination: {
          labelRowsSelect: 'registros'
        },
        toolbar: {
          searchPlaceholder: 'Pesquisar',
        },
        body: {
          emptyDataSourceMessage: 'Sem usuários cadastrados',
          editRow: {
            deleteText: 'Deseja realmente excluir?'
          }
        }
      }}
      editable={{ onRowDelete: (row) => destroyUser({
        variables: {
          userId: row.id
        }})
      }}
    />
  )
}

export default UsersTable
